export default __webpack_public_path__ + "static/media/banner-image.4a22608c.png";